import axios from '../axios';
import config from '../../config';
const { leaderURL } = config;
const clubhub = {
  getTriainingCamps(params) {
    return axios(`${leaderURL}/triaining-camps`, {
      method: 'get',
      params,
    });
  },
  //   女子球员训练营
  getWomanTriainingCamps(params) {
    return axios(`${leaderURL}/woman/triaining-camps`, {
      method: 'get',
      params,
    });
  },
  getTriainingCamp(params, id) {
    return axios(`${leaderURL}/triaining-camp/${id}`, {
      method: 'get',
      params,
    });
  },
  getTriainingCampContent(params) {
    return axios(`${leaderURL}/triaining-camp/content`, {
      method: 'get',
      params,
    });
  },
  // 训练营内容
  campContentApi(params, id) {
    return axios(`${leaderURL}/triaining-camp/content/${id}`, {
      method: 'get',
      params,
    });
  },
  // 训练营 日程
  campScheduleApi(params, id) {
    return axios(`${leaderURL}/triaining-camp/${id}/schedule`, {
      method: 'get',
      params,
    });
  },
  // 训练营梯队列表
  campTeamListApi(params, id) {
    return axios(`${leaderURL}/triaining-camp/${id}/teams`, {
      method: 'get',
      params,
    });
  },
  // 训练营 球员列表
  campPlayerListApi(params, id) {
    return axios(`${leaderURL}/triaining-camp/team/${id}/players`, {
      method: 'get',
      params,
    });
  },
  // 训练营 球员列表
  teensCampSelectionList(params, id) {
    return axios(`${leaderURL}/triaining-camp/${id}/selectors`, {
      method: 'get',
      params,
    });
  },
  // 训练营 职员列表
  campStaffListApi(params, id) {
    return axios(`${leaderURL}/triaining-camp/${id}/coaches`, {
      method: 'get',
      params,
    });
  },
  // 青训营视频列表
  getCampVideoList(params, id) {
    return axios(`${leaderURL}/triaining-camp/${id}/videos`, {
      method: 'get',
      params,
    });
  },
};

export default clubhub;
